module.exports = __webpack_public_path__ + "static/media/03.754e84ce.jpg";